// removed by extract-text-webpack-plugin
module.exports = {"base":"AnnouncementOverlay_base--ksJ8e","contentWrapper":"AnnouncementOverlay_contentWrapper--395m_","contentWrapper__blur":"AnnouncementOverlay_contentWrapper__blur--1x2hx","contentWrapperBlur":"AnnouncementOverlay_contentWrapper__blur--1x2hx","back":"AnnouncementOverlay_back--kHbWR","header":"AnnouncementOverlay_header--3BT4q","main":"AnnouncementOverlay_main--uMzVG","footer":"AnnouncementOverlay_footer--tWezs","confirmationScreen":"AnnouncementOverlay_confirmationScreen--xwaLc"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/AnnouncementOverlay/AnnouncementOverlay.scss
// module id = 2334
// module chunks = 11